import { Api } from 'utils';

class ProfileService {
		
	static get = async (params?: any) => Api.createResponse('profile',params);
	static save = async (params?: any) => Api.createResponse('profile/save',params);
	static deleteAccount = async (params?: any) => Api.createResponse('profile/delete-account',params);
	static saveBankData = async (params?: any) => Api.createResponse('profile/save-bank-data',params);
	static setDefaultBankData = async (params?: any) => Api.createResponse('profile/set-default-bank-data',params);
	static deleteBankData = async (params?: any) => Api.createResponse('profile/delete-bank-data',params);
	static changeFile = async (params?: any) => Api.createResponse('profile/change-file',params);

}

export default ProfileService;